import { Voter } from "@activecollab/security";

export class DiscussionVoter extends Voter {
  attributes = ["edit"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject.class === "Discussion";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "edit": {
        if (user.class === "Client") {
          return subject.created_by_id === user.id;
        }
        return true;
      }
    }
    throw new Error("This code should not be reached!");
  }
}
